import {useContext} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";

export default function useAuthorityConfiguration()
{
    let {getAuthorityConfiguration} = useContext(GlobalContext);
    return getAuthorityConfiguration();
}